export const COLORS_CHART = [
  "#34c38f",
  "#556ee6",
  "#f46a6a",
  "#50a5f1",
  "#f1b44c",
  "#b644b8fa",
];

export const ALL_STORE = "ALL_STORE";
export const ALL_BU = "ALL_BU";

export const TYPE_FILTER_INVOICE_ERROR = {
  INVOICE: "INVOICE", // Hóa đơn
  INVOICE_WAREHOUSES: "INVOICE_WAREHOUSES", // Phiếu xuất kho vc nội bộ
  INVOICE_AGENT: "INVOICE_AGENT", // Phiếu xuất kho gửi bán đại lý
};

export const SCREEN_FILTER_CODE = {
  INVOICE_ALL: "INVOICE_ALL",
  INVOICE_NEW: "INVOICE_NEW",
  INVOICE_RELEASE: "INVOICE_RELEASE",
  INVOICE_WAIT_RELEASE: "INVOICE_WAIT_RELEASE",
  INVOICE_CANCEL: "INVOICE_CANCEL",
  INVOICE_REPLACE: "INVOICE_REPLACE",
  INVOICE_ADJUST: "INVOICE_ADJUST",

  INVOICE_POS_ALL: "INVOICE_POS_ALL",
  INVOICE_POS_NEW: "INVOICE_POS_NEW",
  INVOICE_POS_OF_PHASE: "INVOICE_POS_OF_PHASE",

  PHASE_INVOICE_POS: "PHASE_INVOICE_POS",
};
